const FLAG = "apollo_staff_session";

// Il token staff vive in un cookie httpOnly impostato dal server (non accessibile a JavaScript).
// Qui resta solo un indicatore non sensibile con la scadenza, per sapere se mostrare l'area admin.
export const hasStaffSession = () => {
  const exp = Number(localStorage.getItem(FLAG) || 0);
  if (exp > Date.now()) return true;
  localStorage.removeItem(FLAG);
  return false;
};

export const markStaffSession = (hours = 12) => localStorage.setItem(FLAG, String(Date.now() + hours * 3600 * 1000));
export const clearStaffSession = () => localStorage.removeItem(FLAG);
